<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label>Nome <required-field /></label>
                <b-form-input aria-describedby="labelField" :state="errors.some((e) => e.field === 'label')?false:null"
                              type="text" id="label" v-model="profile.label" aria-required="true"
                              :required=true></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label>Codice <required-field /></label>
                <b-form-input aria-describedby="codeField" :state="errors.some((e) => e.field === 'code')?false:null"
                              type="text" id="code" v-model="profile.code" aria-required="true"
                              :required=true disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label>Descrizione</label>
                <b-form-input aria-describedby="idTypeDescriptionField"
                              type="text" id="idTypeDescriptionField" v-model="profile.description"
                              aria-required="true"
                              :required=true></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label for="company">Azienda</label>
                <v-select :class="errors.some((e) => e.field === 'company') ? 'error' :''" id="company" :options="options"
                          v-model="profile.company"
                          @search="onSearch">
                  <template slot="no-options">
                    Scrivi per cercare l'azienda..
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="d-flex w-100 justify-content-between">
                      <h5 class="mb-1">{{option.label}}</h5>
                      <small class="ml-3">({{ option.code }})</small>
                    </div>
                  </template>
                  <template slot="option" slot-scope="option">
                    <div class="d-flex w-100 justify-content-between">
                      <h5 class="mb-1">{{option.label}}</h5>
                      <small>({{ option.code }})</small>
                    </div>
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label for="jsonData">JSON DATA</label>
                <codemirror id="jsonData" v-model="jsonAsString" :options="cmOptionsJson"></codemirror>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label for="jsonXmlData">XML DATA</label>
                <codemirror id="jsonXmlData" v-model="profile.jsonXmlData" :options="cmOptionsXml"></codemirror>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label>ID Type Value</label>
                <b-table :stacked="stacked" :dark="dark" :hover="hover" :striped="striped" :bordered="bordered"
                         :small="small"
                         :fixed="fixed"
                         :sortBy="sortBy"
                         responsive="sm" :items="profile.idTypeValues" :fields="captions"
                         :current-page="currentPage"
                         :per-page="perPage">
                  <template slot="actions" slot-scope="data">
                    <button class="btn btn-danger" @click="deleteIdType(data.item)">{{$t('page.generic.remove')}}</button>
                  </template>
                </b-table>
                <nav>
                  <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev"
                                next-text="Next" hide-goto-end-buttons/>
                </nav>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label for="idTypeValueCodeField">Codice</label>
                <b-form-input aria-describedby="idTypeValueCodeField"
                              type="text" id="idTypeValueCodeField" v-model="idTypeValue.code" aria-required="true"
                              :required=true></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <b-form-group>
                  <label for="idTypeValueIdTypeField">IdType</label>
                  <v-select id="idTypeValueIdTypeField" label="description" v-model="idTypeValue.idType"
                            :options="idTypes"></v-select>
                </b-form-group>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label for="idTypeValueOidField">Oid</label>
                <v-select id="idTypeValueOidField" label="description" v-model="idTypeValue.oid"
                          :options="oids"></v-select>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label for="idTypeDescriptionField">Descrizione</label>
                <b-form-textarea aria-describedby="idTypeDescriptionField"
                              type="text" id="idTypeDescriptionField" v-model="idTypeValue.description"
                              aria-required="true"
                              :required=true></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <button class="btn btn-success float-right padder" type="button" @click="addIdType" :disabled='isDisabled'>
                {{ $t('actions.add') }}
              </button>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col sm="12">
              <button class="btn btn-success float-right padder" type="button" @click="updateProfile">
                Salva
              </button>
              <router-link class="btn btn-primary float-right" role="button" :to="{name: 'profilesRoute'}">
                Annulla
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import miniToastr from 'mini-toastr' //ES6
  import PageTitle from '@/components/PageTitle'
  import ProfileService from '@/services/ProfileService'
  import CompanyService from '@/services/CompanyService'
  import OidService from '../../services/OidService'
  import IdTypeService from '../../services/IdTypeService'

  import {codemirror} from 'vue-codemirror'
  import i18n from '../../config/i18n'
  // require styles
  import 'codemirror/lib/codemirror.css'
  import 'codemirror/mode/javascript/javascript.js'
  import 'codemirror/mode/xml/xml.js'
  import vSelect from 'vue-select'
  import {_} from 'vue-underscore';
  import RequiredField from "../../components/RequiredField";

  const profileService = ProfileService.build();
  const companyService = CompanyService.build();
  const oidService = OidService.build();
  const idTypeService = IdTypeService.build();

  export default {
    name: 'profileEdit',
    inheritAttrs: false,
    components: {
      RequiredField,
      PageTitle,
      codemirror,
      vSelect
    },
    props: {
      id: {
        required: true
      },
      stacked: {
        type: String,
        default: 'sm'
      },
      hover: {
        type: Boolean,
        default: true
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      },
      perPage: {
        type: Number,
        default: 7
      },
      dark: {
        type: Boolean,
        default: false
      },
      sortBy: {
        type: String,
        default: 'code'
      },
      fields: {
        type: Array,
        default: () =>
          [
            {
              key: 'actions',
              sortable: false,
              label: ''
            },
            {
              key: 'code',
              sortable: true,
              label: i18n.t('page.generic.code')
            },
            {
              key: 'description',
              sortable: true,
              label: i18n.t('page.generic.description')
            },
            {
              key: 'idType.code',
              sortable: true,
              label: i18n.t('model.idType.code')
            },
            {
              key: 'oid.code',
              sortable: true,
              label: i18n.t('model.oid.code')
            },
            {
              key: 'actions',
              sortable: false,
              label: ''
            }
          ]
      },

    },
    data() {
      return {
        profile: {},
        errors: [],
        options: [],
        cmOptionsJson: {
          tabSize: 4,
          styleActiveLine: true,
          lineNumbers: true,
          line: true,
          mode: 'text/javascript',
          lineWrapping: true,
          theme: 'default'
        },
        cmOptionsXml: {
          tabSize: 4,
          styleActiveLine: true,
          lineNumbers: true,
          line: true,
          mode: 'application/xml',
          lineWrapping: true,
          theme: 'default'
        },
        currentPage: 1,
        idTypeValue: {},
        idTypes: [],
        oids: [],
      }
    },
    computed: {
      totalRows: function () {
        return this.getRowCount()
      },
      captions: function () {
        return this.fields
      },
      isDisabled: function(){
        return !((!!this.idTypeValue.code) &&  (!!this.idTypeValue.idType))
      },
      jsonAsString: {
        // getter
        get: function () {
          return JSON.stringify(this.profile.jsonData, null, 4)
        },
        // setter
        set: function (newValue) {
          this.profile.jsonData = JSON.parse(newValue)
        }
      }
    },
    created() {
      miniToastr.init(); // config can be passed here miniToastr.init(config)
      miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
      this.fetchData()
    },
    methods: {
      async fetchData() {
        try {
          this.profile = await profileService.read(this.id)
        } catch (exception) {
          exception.errors.forEach(function (element) {
            miniToastr.error(element.message);
          });
        }
        let oidList = await oidService.search({});
        let idTypeList = await idTypeService.search({});
        this.oids = oidList.data;
        this.idTypes = idTypeList.data;
      },
      async updateProfile() {
        try {
          let updatedProfile = Object.assign(this.profile, {jsonData: this.jsonAsString})
          await profileService.update(updatedProfile)
          this.$router.push({name: 'profilesShowRoute', params: {id: this.id}})
          miniToastr.info("Profilo aggiornato con successo");
        } catch (exception) {
          this.errors = exception.errors
          exception.errors.forEach(function (element) {
            miniToastr.error(element.message);
          });
        }

      },
      onSearch(search, loading) {
        loading(true);
        this.search(loading, search, this);
      },
      getRowCount: function () {
        return this.profile.idTypeValues ? this.profile.idTypeValues.length : 0
      },
      addIdType() {
        this.profile.idTypeValues.push(Object.assign({}, this.idTypeValue))
        this.idTypeValue = {}
      },
      deleteIdType(item) {
        this.profile.idTypeValues.splice(this.profile.idTypeValues.findIndex(element =>
          element.code === item.code && element.description === item.description && element.idType === item.idType && element.oid === item.oid), 1);
      },
      search: _.debounce(async (loading, search, vm) => {
        try {
          let result = await companyService.search({max: 100});
          vm.options = result.data || [];
        } catch (exception) {
          miniToastr.error(exception.message);
        }
        loading(false);
      }, 350)

    }
  }
</script>

<style>
  .error > .clearfix{
    border: 1px solid #f3464a
  }
</style>
